import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'properties/style/header-bgcolor.ejs';
import { pickerCfg } from 'pickerCfg.js';
import themeService from 'ThemeService.js';
import util from 'util/Util.js';

class StyleHeaderBGColorView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=color]': 'updateColorAttributes',
            'change input[type=text]': 'updateColorAttributesWithValidation',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus'
        };
        
        return this;
    }


    render() {
        super.render();

        let props = this.resolveThemeColors(this.model, ['titleBackgroundColor']);

        this.$el.html(this.template(props));

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();

        return this;
    }

}

export default StyleHeaderBGColorView;
